// The order the RS Automotive lookups are tried in. TME yards get better data from the plate; a
// VIN-keyed yard may have no plate at all, so the VIN leads there; everyone else keys on KType.
import { VehicleIdentifierType } from "../models/Vehicle";

export type RsLookupKey = "vrm" | "vin" | "ktype";

export const rsLookupOrder = ({ hasTme, identifierType }: { hasTme: boolean; identifierType: VehicleIdentifierType }): RsLookupKey[] => {
  if (identifierType === "Vin") return ["vin", "ktype", "vrm"];

  return hasTme ? ["vrm", "vin", "ktype"] : ["ktype", "vrm", "vin"];
};
